import { trackPageView } from '@kanbu/shared';
import { createRouter } from '@tanstack/react-router';
import { posthog } from 'posthog-js';

import { AppSettings } from '@/constants';

import { defaultQueryClient } from './query-client.js';
import { routeTree } from '../routeTree.gen.js';

/**
 * Tanstack router base configuration
 */
export const router = createRouter({
  routeTree,
  context: {
    queryClient: defaultQueryClient,
  },
});

let previousPath: string | null = null;

router.history.subscribe(() => {
  const currentPath = router.history.location.pathname;

  // Track page view with PostHog and GTM
  if (AppSettings.env === 'production') {
    trackPageView(posthog, {
      previousPath,
      currentPath,
    });
  }

  // Update previous path
  previousPath = currentPath;
});

// Register things for typesafety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
